/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './searchActors.defs.js'
export { main as default } from './searchActors.defs.js'
